var map = {
	"./logo_cardio.png": [
		3289,
		[
			289
		]
	],
	"./logo_gine.png": [
		8744,
		[
			744
		]
	],
	"./logo_vallhebron.png": [
		4806,
		[
			806
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(function() {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(function() { return __webpack_require__.t(id, 1 | 16); });
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 5497;
module.exports = webpackAsyncContext;